import React from 'react'
import { Container, Row } from 'reactstrap'
import PurchaseTeamList from './PurchaseTeamList'


export default function PurchaseTeam() {
  return (
    <>
      <Container fluid>
        <Row>
            <PurchaseTeamList/>
            
        </Row>
      </Container>
    </>
  )
}